module.exports = __webpack_public_path__ + "static/media/invoicing.c215d176.webp";